import { render, staticRenderFns } from "./CookiesLayout.vue?vue&type=template&id=66bcd84a&"
import script from "./CookiesLayout.vue?vue&type=script&lang=js&"
export * from "./CookiesLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports